"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeError = void 0;
var deserializeError = function (error) {
    var e = new Error(error.message);
    e.stack = error.stack;
    e.name = error.name;
    return e;
};
exports.deserializeError = deserializeError;
